import { Link } from "react-router-dom";
import Nav from "@/components/sections/Nav";
import Footer from "@/components/sections/Footer";
import { POSTS } from "@/data/blog";
import { ArrowUpRight } from "lucide-react";

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

export default function Journal() {
  return (
    <main
      data-testid="journal-page"
      className="bg-[#F9F8F6] text-[#2D332B] min-h-screen"
    >
      <Nav />

      <section className="pt-40 pb-16 sm:pt-48 sm:pb-24">
        <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
          <p className="text-[11px] tracking-[0.4em] uppercase text-[#5C6658] mb-6">
            The Journal
          </p>
          <h1 className="font-[Outfit] font-extralight text-[#2D332B] text-[44px] sm:text-[72px] lg:text-[88px] leading-[0.98] tracking-[-0.02em] max-w-4xl">
            Notes from the
            <br />
            <span className="italic text-[#8A9A86]">practice.</span>
          </h1>
          <p className="mt-8 max-w-xl text-[15px] sm:text-[17px] leading-relaxed text-[#5C6658]">
            Observations from designing, planting and caring for luxury
            biophilic interiors across India — from the studio floor to the
            industry at large.
          </p>
        </div>
      </section>

      <section className="pb-32 sm:pb-40">
        <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10">
            {POSTS.map((p, i) => (
              <Link
                to={`/journal/${p.slug}`}
                key={p.slug}
                data-testid={`journal-card-${p.slug}`}
                className={`group block ${
                  i === 0 ? "md:col-span-2 lg:col-span-2" : ""
                }`}
              >
                <article className="h-full flex flex-col bg-[#F9F8F6] border border-[#E5E1DB] rounded-sm overflow-hidden hover:border-[#8A9A86] transition-colors duration-500">
                  <div
                    className={`relative overflow-hidden ${
                      i === 0 ? "aspect-[16/9]" : "aspect-[4/3]"
                    }`}
                  >
                    <img
                      src={p.cover}
                      alt={p.title}
                      className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-[1.04]"
                    />
                  </div>
                  <div className="p-7 sm:p-9 flex-1 flex flex-col">
                    <p className="text-[10px] tracking-[0.3em] uppercase text-[#5C6658]">
                      {formatDate(p.published_at)} · {p.reading_minutes} min read
                    </p>
                    <h2
                      className={`mt-4 font-[Outfit] font-light text-[#2D332B] leading-[1.1] ${
                        i === 0
                          ? "text-[28px] sm:text-[36px]"
                          : "text-[22px] sm:text-[26px]"
                      }`}
                    >
                      {p.title}
                    </h2>
                    {p.subtitle && (
                      <p className="mt-3 text-[15px] leading-relaxed text-[#5C6658] italic">
                        {p.subtitle}
                      </p>
                    )}
                    <p className="mt-5 text-[14px] leading-relaxed text-[#5C6658] line-clamp-3">
                      {p.excerpt}
                    </p>
                    <span className="mt-8 inline-flex items-center gap-2 text-[11px] tracking-[0.3em] uppercase text-[#2D332B] group-hover:text-[#8A9A86] transition-colors">
                      Read essay <ArrowUpRight className="w-3.5 h-3.5" />
                    </span>
                  </div>
                </article>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
